import React, { useEffect, useRef } from "react";
import styles from "./Gallery.module.css";

export default function ViewerModal({
  items,
  index,
  onClose,
  onPrev,
  onNext,
  setIndex,
}) {
  const item = items[index];
  const overlayRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    }
    document.addEventListener("keydown", onKey);
    // prevent background scroll
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = original;
    };
  }, [onClose, onPrev, onNext]);

  useEffect(() => {
    // autoplay video when opened
    if (item.type === "video" && videoRef.current) {
      // attempt autoplay
      videoRef.current.currentTime = 0;
      const play = videoRef.current.play();
      if (play && typeof play.then === "function") {
        play.catch(() => {
          // autoplay blocked — leave controls visible for user
        });
      }
    }
  }, [item]);

  function onOverlayClick(e) {
    if (e.target === overlayRef.current) onClose();
  }

  return (
    <div
      className={styles.overlay}
      role="dialog"
      aria-modal="true"
      ref={overlayRef}
      onClick={onOverlayClick}
    >
      <div className={styles.viewer}>
        <button
          className={`${styles.nav} ${styles.prev}`}
          onClick={onPrev}
          aria-label="Previous"
        >
          ‹
        </button>

        <div className={styles.content}>
          <button
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>

          {item.type === "image" ? (
            <img
              src={item.src}
              alt={item.title || "gallery image"}
              className={styles.fullImage}
            />
          ) : (
            <video
              ref={videoRef}
              className={styles.fullVideo}
              controls
              src={item.src}
            >
              Your browser does not support the video tag.
            </video>
          )}

          {item.title && <div className={styles.caption}>{item.title}</div>}
        </div>

        <button
          className={`${styles.nav} ${styles.next}`}
          onClick={onNext}
          aria-label="Next"
        >
          ›
        </button>
      </div>

      {/* small strip thumbnails at bottom */}
      <div className={styles.strip}>
        {items.map((it, i) => (
          <button
            key={i}
            className={`${styles.stripItem} ${
              i === index ? styles.stripActive : ""
            }`}
            onClick={() => setIndex(i)}
            aria-label={`Open ${i + 1}`}
          >
            <img src={it.thumb || it.src} alt={it.title || `thumb-${i}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
